import { createSelector } from 'reselect';

import getBusinessTypeFromQuery from '@shared/selectors/getBusinessTypeFromQuery';

const getBusinessType = createSelector(
  getBusinessTypeFromQuery,
  // eslint-disable-next-line arrow-body-style
  businessType => {
    return businessType;
  },
);

export default getBusinessType;
